import styled from 'styled-components';
import posed from 'react-pose';
import { Props } from './index';

const PosedSidebarContent = posed.div(({ duration }: { duration: number }) => ({
  enter: {
    x: 0,
    transition: { x: { duration } },
  },
  exit: {
    x: ({ side }: Pick<Props, 'side'>) => (side === 'right' ? '100%' : '-100%'),
    transition: {
      x: { duration },
    },
  },
}));

export const StyledSidebarContent = styled(PosedSidebarContent)<{
  side: 'left' | 'right';
}>`
  position: fixed;
  top: 0;
  height: 100vh;

  ${({ side }) => (side === 'right' ? 'right: 0;' : 'left: 0;')}
`;
